// スライダー

import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const aboutGallery01Options = {
  type: 'loop',
  arrows: false,
  pagination: false,
  drag: 'free',
  gap: 20,
  fixedWidth: 400,
  focus: 'center',
  breakpoints: {
    768: {
      fixedWidth: 280,
    },
    640: {
      fixedWidth: 200,
    },
  },
  autoScroll: {
    speed: 0.5,
    pauseOnFocus: false,
    pauseOnHover: false,
  },
};

const aboutGallery01 = document.querySelector('.aboutGallery01');

if(aboutGallery01) {
  const aboutGallery01Splide = new Splide('.aboutGallery01', aboutGallery01Options);
  aboutGallery01Splide.mount({ AutoScroll });
}

const aboutGallery02Options = {
  direction: "rtl",
  type: 'loop',
  arrows: false,
  pagination: false,
  drag: 'free',
  gap: 20,
  fixedWidth: 400,
  focus: 'center',
  breakpoints: {
    768: {
      fixedWidth: 280,
    },
    640: {
      fixedWidth: 200,
    },
  },
  autoScroll: {
    speed: 0.5,
    pauseOnFocus: false,
    pauseOnHover: false,
  },
};

const aboutGallery02 = document.querySelector('.aboutGallery02');

if(aboutGallery02) {
  const aboutGallery02Splide = new Splide('.aboutGallery02', aboutGallery02Options);
  aboutGallery02Splide.mount({ AutoScroll });
}